import { Observable } from "../../events";
import { IsDisposable } from "../../types";
import { TileNavigationState } from "../navigation";
import { TileNavigationApi } from "../navigation/tiles.navigation.api";
import { hasTileSelectionContext } from "../pipeline";
import { TileProvider } from "../providers";
import { TileView } from "./tiles.map.view";
export class TileMapLayerView extends TileProvider {
    constructor(layer, display, source, selectionContext) {
        super(layer.provider);
        this._ownSource = false;
        this._navigation = null;
        this._navigationObserver = null;
        this._api = null;
        this._display = null;
        this._displayObserver = null;
        this._layer = layer;
        this._layerObserver = layer.propertyChangedObservable.add(this._onLayerPropertyChanged.bind(this));
        this.navigationState = this._buildNavigation();
        this.display = display;
        this._source = source ?? this._buildSource();
        this._source?.linkTo(this);
        if (!selectionContext) {
            if (hasTileSelectionContext(this._source)) {
                selectionContext = this._source;
            }
        }
        this._selectionContext = selectionContext;
    }
    get navigationApi() {
        return this._api;
    }
    get weightChangedObservable() {
        if (!this._weightChangedObservable) {
            this._weightChangedObservable = new Observable();
        }
        return this._weightChangedObservable;
    }
    get weight() {
        return this._layer.weight;
    }
    get name() {
        return this._layer.name;
    }
    get layer() {
        return this._layer;
    }
    get display() {
        return this._display;
    }
    get navigationState() {
        return this._navigation;
    }
    set navigationState(value) {
        if (this._navigation !== value) {
            const tmp = this._navigation;
            if (tmp) {
                this._navigationObserver?.disconnect();
                this._navigationObserver = null;
                this._api?.dispose();
                this._api = null;
            }
            this._navigation = value;
            if (this._navigation) {
                this._api = new TileNavigationApi(this._navigation, this.metrics);
                this._navigationObserver = this._navigation.propertyChangedObservable.add(this._onNavigationPropertyChanged.bind(this));
            }
            this._onNavigationChanged(tmp, value);
        }
    }
    set display(value) {
        if (this._display !== value) {
            const tmp = this._display;
            if (tmp) {
                this._displayObserver?.disconnect();
                this._displayObserver = null;
            }
            this._display = value;
            if (this._display) {
                this._displayObserver = this._display.propertyChangedObservable.add(this._onDisplayPropertyChanged.bind(this));
            }
            this._onDisplayChanged(tmp, value);
        }
    }
    get source() {
        return this._source;
    }
    dispose() {
        super.dispose();
        this._navigation?.dispose();
        this._source?.unlinkFrom(this);
        if (this._ownSource && IsDisposable(this._source)) {
            this._source?.dispose();
        }
        this._layerObserver?.disconnect();
        this._displayObserver?.disconnect();
        this._navigationObserver?.disconnect();
    }
    _buildSource() {
        this._ownSource = true;
        return new TileView();
    }
    _buildNavigation() {
        return new TileNavigationState(undefined, undefined, undefined, this.metrics);
    }
    _onLayerPropertyChanged(eventData, eventState) {
        switch (eventData.propertyName) {
            case "weight": {
                if (this._weightChangedObservable && this._weightChangedObservable.hasObservers()) {
                    this._weightChangedObservable.notifyObservers(this, -1, this, this);
                }
                break;
            }
        }
        this.invalidate();
    }
    _onNavigationChanged(oldValue, newValue) {
        this.invalidate();
    }
    _onNavigationPropertyChanged(eventData, eventState) {
        this.invalidate();
    }
    _onDisplayChanged(oldValue, newValue) {
        this.invalidate();
    }
    _onDisplayPropertyChanged(eventData, eventState) {
        this.invalidate();
    }
    _doValidate() {
        this._selectionContext?.setContext(this.navigationState, this._display, this.metrics, { zoomOffset: this.layer.zoomOffset ?? 0 });
    }
}
//# sourceMappingURL=tiles.map.layerView.js.map